import { createStyles } from '@material-ui/styles';
export default () =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 32,
      textAlign: 'center',
    },
    icon: {
      fontSize: 80,
      color: '#00b871',
      marginBottom: 16,
    },
    message: {
      fontSize: 24,
      fontWeight: 600,
      marginBottom: 8,
      color: '#515350',
    },
    subMessage: {
      fontSize: 16,
      color: '#727272',
      marginBottom: 24,
    },
    button: {
      marginTop: 16,
      backgroundColor: '#0064af',
      color: '#fff',
      padding: '10px 24px',
      fontSize: 14,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#155fa0',
      },
    },
  });
